module.exports = __webpack_public_path__ + "img/lottery-pointer.56bc93f0.png";